/**
 * Выполняет переход по указанному URL, используя метод GET или отправляет данные методом POST,
 * если найден ближайший родительский элемент с атрибутом data-all, содержащим данные для отправки.
 *
 * @param {HTMLElement} elem Элемент, вызывающий функцию.
 * @param {string} href Ссылка для перехода или отправки данных.
 * @param {boolean} get Определяет, использовать ли принудительно метод GET для перехода.
 * @param {Event} event Событие клика (для определения средней кнопки мыши).
 */
export function href({ elem = null, event, url, get = false, data = {}, redirect = false, method = 'post', debugMode = false }) {
  if (debugMode) {
    debugger;
  }
  // Находим ближайший элемент с атрибутом data-all
  let target = elem ? elem.closest('[data-all]') : null;
  let sData = Object.assign(getDataAll(target), data);
  method = method.toLowerCase();

  if (method === 'get') {
    get = true;
  }

  if (redirect) {
    url = Redirect.route(redirect, sData);
  }

  // Проверяем, был ли клик средней кнопкой мыши (button === 1)
  const isMiddleClick = event && event.button === 1;

  if (isMiddleClick) {
    // Открываем ссылку в новой вкладке
    window.open(url, '_blank');
    return;
  }
  //   console.log(data);
  //   return;
  // Проверяем, есть ли данные для отправки
  if (Object.keys(sData).length === 0 || get == true) {
    // Если данных нет, производим переход по ссылке методом GET
    window.location.href = url;
  } else {
    // Создаём временную форму для отправки данных методом POST
    let form = document.createElement('form');
    form.action = url;
    form.method = 'POST'; // Метод отправки - POST

    // Для каждого свойства объекта data создаём скрытое поле в форме
    for (let key in sData) {
      if (sData.hasOwnProperty(key)) {
        let input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = sData[key];
        form.appendChild(input);
      }
    }

    // Добавляем форму в тело документа
    document.body.appendChild(form);

    // Отправляем форму
    form.submit();

    // Удаляем форму после отправки
    form.remove();
  }
}